import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export enum LabelsFields {
  Singular = 'Singular',
  Plural = 'Plural',
}

class IncidentConfig extends SettingsSubModule {
  @SettingsSubModule.value(`Incident.${LabelsFields.Singular}`, null)
  singular: SettingValue<string>;

  @SettingsSubModule.value(`Incident.${LabelsFields.Plural}`, null)
  plural: SettingValue<string>;
}

class CapaConfig extends SettingsSubModule {
  @SettingsSubModule.value(`CAPA.${LabelsFields.Singular}`, null)
  singular: SettingValue<string>;

  @SettingsSubModule.value(`CAPA.${LabelsFields.Plural}`, null)
  plural: SettingValue<string>;
}

class ActionItemConfig extends SettingsSubModule {
  @SettingsSubModule.value(`ActionItem.${LabelsFields.Singular}`, null)
  singular: SettingValue<string>;

  @SettingsSubModule.value(`ActionItem.${LabelsFields.Plural}`, null)
  plural: SettingValue<string>;
}

class AuditConfig extends SettingsSubModule {
  @SettingsSubModule.value(`QMSAudit.${LabelsFields.Singular}`, null)
  singular: SettingValue<string>;

  @SettingsSubModule.value(`QMSAudit.${LabelsFields.Plural}`, null)
  plural: SettingValue<string>;
}

class FindingConfig extends SettingsSubModule {
  @SettingsSubModule.value(`QMSFinding.${LabelsFields.Singular}`, null)
  singular: SettingValue<string>;

  @SettingsSubModule.value(`QMSFinding.${LabelsFields.Plural}`, null)
  plural: SettingValue<string>;
}

class SupplierQualificationConfig extends SettingsSubModule {
  @SettingsSubModule.value(`QMSSupplierQualification.${LabelsFields.Singular}`, null)
  singular: SettingValue<string>;

  @SettingsSubModule.value(`QMSSupplierQualification.${LabelsFields.Plural}`, null)
  plural: SettingValue<string>;
}

export class LabelsModule extends SettingsModule {
  @SettingsModule.value(IncidentConfig) incident: IncidentConfig;
  @SettingsModule.value(CapaConfig) capa: CapaConfig;
  @SettingsModule.value(ActionItemConfig) actionItem: ActionItemConfig;
  @SettingsModule.value(AuditConfig) audit: AuditConfig;
  @SettingsModule.value(FindingConfig) finding: FindingConfig;
  @SettingsModule.value(SupplierQualificationConfig) supplierQualification: SupplierQualificationConfig;
}
